module.exports = __webpack_public_path__ + "static/media/NSS1.2fd1cd59.jpg";